export default {"src":"/org/_next/static/media/my-details.e6884246.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};